'use client';
import React, { PropsWithChildren } from 'react';

import { usePathname } from 'next/navigation';

import { Link, LinkProps } from '@heroui/link';

function NavLink(
  props: PropsWithChildren<
    LinkProps & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>
  >
) {
  const asPath = usePathname();
  const string = props.href ?? '';
  const active = asPath === props.href;
  const parent = asPath?.startsWith(string);
  const attrs = { ...props } as Record<string, unknown>;

  if (active) {
    attrs['aria-current'] = 'page';
    attrs.isActive = true;
  }
  if (parent) {
    attrs['data-parent'] = 'true';
    attrs.isActive = true;
  }

  return (
    <Link
      {...(attrs as LinkProps)}
      className={`${props.className} cursor-pointer`}
    >
      {props.children}
    </Link>
  );
}

export default NavLink;
